import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "relative flex justify-center items-center border border-dashed border-primary-600 w-[8.875rem] h-20 rounded-lg overflow-hidden z-0 !bg-foreground-100 cursor-pointer",
    img: "rounded-tl rounded-tr h-auto max-h-[230px] object-cover",
    footer: "py-2 text-center flex items-center justify-items-center justify-center w-full",
    footerLink: "border-0",
    footerText: "mr-1 text-sm leading-6",
    icon: "w-5 h-5 text-primary-600 cursor-pointer",
    previewContainer: "flex",
    thumbButtons: "rounded-full bg-foreground-100 absolute top-0 right-0 p-2 z-40",
  },
});
